<template>
    <section class="content">
      <div class="box box-info">
      
      <div class="p-toolbar p-component mb-4">
        <crmDealDetailsDialog ref="openDialog"/>
        </div>
          <!-- <a href="#"  @click.prevent="exportCSV()" v-if="this.crmDealLists.length > 0">
            <img src="../../../../static/img/excel.png" style="margin-top: 1em;width: 4%;float: right;"/>
         </a> -->
      <DataTable ref="po"
      :value="crmDealLists"
      :paginator="true"
      :rows="8" :filters="filters"
      class="p-datatable-responsive p-datatable-customers"
      >
      <Column header="S.n">
        <template #body="slotProps">
        {{slotProps.index+1}}
        </template>
      </Column>
      <Column :sortable="true"   header="Contact Person" field="contactName" filterMatchMode="contains" >
         <template #filter>
           <InputText type="text" class="p-column-filter" v-model="filters['contactName']" />
         </template>
      </Column>
      <Column :sortable="true"
        header="Company Name"
        field="companyName"
        filterMatchMode="contains"
      >
      <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['companyName']" />
        </template>
      </Column>

    <Column :sortable="true" header="Name" field="dealName" filterMatchMode="contains" >
     <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['dealName']" />
        </template>
      </Column>

      <Column :sortable="true" header="Amount" field="amount"
       filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['amount']" />
        </template>
      </Column>

       <Column :sortable="true" header="Expected Revenue" field="expectedRevenue" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['expectedRevenue']" />
        </template>
      </Column>

      <Column :sortable="true" header="Source" field="leadSourceId" filterMatchMode="contains" >
        <template #body="slotProps">
          {{ getSourceLabel(slotProps.data.leadSourceId) }}
        </template>
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['leadSourceId']" />
        </template>
      </Column>
      <Column :sortable="true" header="Deal Stage" field="dealStage" filterMatchMode="contains" >
        <template #body="slotProps">
          {{ getDealLabel(slotProps.data.dealStage) }}
        </template>
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['dealStage']" />
        </template>
      </Column>

      <Column :sortable="true" header="Probability" field="probability" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['probability']" />
        </template>
      </Column>

     <Column :sortable="true" header="Deal Open Date" field="dealOpenDate"
      filterMatchMode="contains" >
      <template #body="slotProps">
        {{ formatDate(slotProps.data.dealOpenDate) }}
      </template>
         <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['dealOpenDate']" />
        </template>
      </Column>

        <Column :sortable="true" header="Expected Close Date" field="dealCloseDate"
      filterMatchMode="contains" >
      <template #body="slotProps">
        {{ formatDate(slotProps.data.dealCloseDate) }}
      </template>
         <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['dealCloseDate']" />
        </template>
      </Column>

      <Column :sortable="true" header="Description" field="description"
      filterMatchMode="contains" >
         <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['description']" />
        </template>
      </Column>

    <Column header="Action" headerStyle="width: 11em">
        <template #body="slotProps">


            <Button icon="pi pi-pencil" class="p-button-raised p-button-success" @click="editDeal(slotProps.data)" />

            <Button icon="pi pi-trash" class="p-button-danger p-button-sm"   @click="openDialog(slotProps.data.id)"/>

        </template>
      </Column>


      </DataTable>
     </div>
     <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteCrmDeal"/>

   </section>

</template>
<script>
import crmDealDetailsDialog from '../crmDialog/crmDealDetailsDialog.vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'

export default {
  name: 'customer',
  data() {
    return {
      displayBasic: false,
      dialogShow: false,
      columnList: '',
      filters: {}
    }
  },
  computed: {
    crmDealLists() {
      return this.$store.state.crm.crmDealLists
    },
    masterSetupList() {
      return this.$store.state.users.masterSetupList
    },
    sourceList() {
      return this.masterSetupList.filter(item =>
        item.name === 'source'
      )
    },
    stageList() {
      return this.masterSetupList.filter(item =>
        item.name === 'stage'
        )
    }
  },
  mounted() {
    this.crmDealList()
    this.columnNames()
    this.masterSetupLists()
  },
  methods: {
    async masterSetupLists() {
      await this.$store.dispatch('loadMasterSetupList', 'Crm')
    },
    getSourceLabel(value) {
      const sourceItem = this.sourceList.find(item => item.id === value)
      return sourceItem ? sourceItem.value : 'N/A'
    },
    getDealLabel(value) {
      const sourceItem = this.stageList.find(item => item.id === value)
      return sourceItem ? sourceItem.value : 'N/A'
    },
    async deleteCrmDeal(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        accountMasterId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteCrmDeal', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.closeDialog()
        this.dialogShow = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.dialogShow = false
        this.closeDialog()
      }
    },
    editDeal(data) {
      this.$refs.openDialog.editDeal(data)
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Customer List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'customerList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    async crmDealList() {
      await this.$store.dispatch('loadCrmDealList')
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString()
    },
    cancel(data) {
      this.dialogShow = false
    }
  },
  components: {
    Column,
    DataTable,
    Dialog,
    InputText,
    crmDealDetailsDialog,
    Button
  }
}
</script>



// WEBPACK FOOTER //
// crmDealDetails.vue?78d4e748